import {generatePath} from "react-router";

/**
 * The map of all the available AppRoutes in the system
 */
class AppRoutes {
    /**
     * Public Views
     */
    static public = {
        landing: "/",
        spire: "/spire",
        package: "/packages/:slug",
        blogs: "/blogs",
        blog: "/blogs/:slug",
        privacyPolicy: "/privacy-policy",
        biLanding: "/bi",
        biPackageSlug: "bizkey-business-intelligence",
        /** Relative segments for nested routes under the pathless public layout. */
        _relative: {
            landing: "",
            spire: "spire",
            package: "packages/:slug",
            blogs: "blogs",
            blog: "blogs/:slug",
            privacyPolicy: "privacy-policy",
        },
        error: {
            _base: "/error/*",
            base: "/error",
            _relative: {
                notFound: "not-found",
                accessDenied: "access-denied",
                serverError: "server-error",
            },
            notFound: "/error/not-found",
            accessDenied: "/error/access-denied",
            serverError: "/error/server-error",
        },
    };

    /**
     * Generates the path of the given AppRoutes in the system that include route parameters.
     */
    static generateRoute: typeof generatePath = (route, params) => {
        return generatePath(route, params);
    }
}

export default AppRoutes;
